import { html, nothing } from 'lit';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { updateDrawerState } from '../actions/app.action';
import { selectIsGuide } from '../selectors/hero.selectors';
import { selectQuest } from '../selectors/quest.selectors';
import ConfigService from '../services/config.service';
import navigationService from '../services/navigation.service';
import { store } from '../store.js';
import { MenuElement } from './menu.component.js';

const styles = html`
  <style>
    .navbar {
      width: 3.5rem;
      height: 3.6rem;
      position: fixed;
      background-color: var(--app-dashboard-color);
      padding-top: 1rem;
      z-index: 7;
    }

    .navbar-nav {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
    }

    .navbar-nav > li:not(:first-child) {
      display: none;
    }

    .navbar-item {
      width: 100%;
      height: 70px;
      -moz-transition: all 0.05s ease-in-out;
      transition: all 0.05s ease-in-out;
    }

    .navbar-item:first-child {
      height: 50px;
    }

    .navbar-item a:hover {
      width: 120%;
      background-color: var(--app-primary-color);
    }

    .navbar-item:last-child {
      margin-inline: auto;
    }

    .navbar-link {
      display: flex;
      align-items: center;
      height: 5rem;
      color: white;
      text-decoration: none;
      border: none;
      background: none;
      cursor: pointer;
    }

    .link-text {
      display: none;
    }

    img {
      width: 60%;
      height: 60%;
      margin: auto;
    }

    .navbar-icon-light-on-dark {
      filter: brightness(0) invert(1);
    }

    hr {
      background-color: white;
      width: 75%;
      height: 2%;
      margin: auto;
      border: 1px solid white;
      border-radius: 5px;
      display: none;
    }

    #burger {
      height: 2.5rem;
      padding-bottom: 1rem;
      outline: none;
    }

    #burger img {
      height: 1.2rem;
      margin-right: 10px;
      margin-top: 10px;
      margin-left: 10px;
    }

    @media (min-height: 910px) and (min-width: 50rem) {
      .navbar {
        height: 100vh;
      }

      .navbar-nav > li:not(:first-child) {
        display: initial;
      }

      hr {
        display: initial;
      }
    }
  </style>
`;

class BurgerMenu extends connect(store)(MenuElement) {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
  }

  menuButtonClicked() {
    store.dispatch(updateDrawerState(true));
  }

  drawerOpenedChanged(event) {
    store.dispatch(updateDrawerState(event.target.opened));
  }

  renderGuideButton() {
    if (this.isGuide) {
      return html`
        <li class="navbar-item">
          <a href="/heroes" title="Heroes" class="navbar-link">
            <img src="images/icons/heroes.svg" />
          </a>
          <span class="link-text">Heroes</span>
        </li>
      `;
    } else {
      return html``;
    }
  }

  renderEditQuestButton() {
    if (this.quest && this.quest.questId) {
      return html`
        <li class="navbar-item">
          <a href="/quest/${this.quest.questId}" title="Edit Quest" class="navbar-link">
            <img src="images/icons/edit.svg" />
          </a>
          <span class="link-text">Edit Quest</span>
        </li>
      `;
    } else {
      return html``;
    }
  }

  renderMenuItem(menuItem){
    return html`
      <li class="navbar-item">
        <a href="${menuItem.route}" title="${menuItem.name}" target="${menuItem.openInNewWindow?'_blank':nothing}" class="navbar-link">
          <img src="${menuItem.icon}" />
        </a>
        <span class="link-text">${menuItem.name}</span>
      </li>
    `
  }

  render() {
    return html`
      ${styles}
      <nav class="navbar">
        <ul class="navbar-nav">
          <!-- Burger Menu -->
          <li class="navbar-item">
            <button class="navbar-link" id="burger" @click="${this.menuButtonClicked}">
              <img src="images/icons/burger.svg" />
            </button>
            <span class="link-text">Expand Menu</span>
          </li>
          ${this.renderMenuItems("main")}
          <!-- Peer Feedback -->
          ${ConfigService.config.PEER_FEEDBACK_ENABLED
            ? html`
                <li class="navbar-item">
                  <a href="/peer-feedback" title="Peer Feedback" class="navbar-link">
                    <img src="images/icons/peer-feedback.svg" />
                  </a>
                  <span class="link-text">Peer Feedback</span>
                </li>
              `
            : html``}
          <hr />
          ${this.renderMenuItems("learning")}

          <hr />
          <!-- Edit Quest -->
          ${this.renderEditQuestButton()}
          ${this.renderMenuItems("quest")}
          <hr />
          <!-- Heroes -->
          ${this.renderGuideButton()}
          <!-- Become Guide -->
          <li class="navbar-item">
            <a href="/become-guide" title="Become a Guide" class="navbar-link">
              <img src="images/icons/request.svg" />
            </a>
            <span class="link-text">Become a Guide</span>
          </li>
          <hr />
          ${this.renderMenuItems("dev")}
        </ul>
      </nav>
    `;
  }

  goToCourse(courseName) {
    if (!courseName) {
      return;
    } else {
      const selectedCourse = this.courses.find(
        (course) => course.name === courseName
      );
      const path = `/course/${selectedCourse.code}`;
      navigationService.navigate(path);
    }
  }

  checkGuide() {
    return this.isGuide ? '' : 'hide';
  }

  static get properties() {
    return {
      selected: {
        type: String,
      },
      drawerOpened: {
        type: Boolean,
      },
      isGuide: {
        type: Boolean,
      },
      quest: Object,
      notificationCount: Number,
      courses: Array,
      projectMoveEnabled: { type: Boolean },
    };
  }


   stateChanged(state) {
    this.drawerOpened = state.app.drawerOpened;
    this.quest = selectQuest(state);
    this.isGuide = selectIsGuide(state);
    switch (state.app.page) {
      case 'tracks':
      case 'course':
      case 'section':
        this.selected = 'tracks';
        break;
      case 'mission':
        this.selected = 'tracks';
        break;
      case 'log':
        this.selected = 'log';
        break;
      default:
        this.selected = state.app.page;
    }
  }
}

window.customElements.define('e-burger-menu', BurgerMenu);
